export interface validableFormWidgetProps {
  isValid?: boolean;
  validationMessage?: string;
  awaitsValidation?: boolean;
  required?: boolean;
}

export const mandatoryFieldLabel = "forms.field.is.mandatory";
